import {Button, IconButton, Stack, Typography} from '@mui/material';
import {useHostName} from 'presentation/hooks';
import Icon from 'presentation/icons';
import {useMediaQueries} from 'presentation/pages';
import React, {useState} from 'react';
import {isIOS} from 'react-device-detect';
import Cookies from 'js-cookie';
import {translations} from 'presentation/translations-new';
import {ProductEnum} from 'presentation/constants/productEnum';
import {StyledContainer, StyledContent, StyledIcon} from './styles';
import {IDownloadApp} from './types';

const {ccg, clinipam, gndi, gndiminas, hapvida, seeApp, useApp, notredamesaude} =
	translations['pt-br'].publicFlow.downloadApp.alert;

export function DownloadApp({marginBottom}: IDownloadApp) {
	const {isMobile} = useMediaQueries();
	const {dataHostNameState} = useHostName();

	const cookieName = `${dataHostNameState.product}.bannerMobileApp`;

	const savedCookie = Cookies.get(cookieName);

	const [openState, setOpenState] = useState(true);

	const linkRedirect = isIOS
		? dataHostNameState.iosStoreLink
		: dataHostNameState.androidStoreLink;

	if (!isMobile || savedCookie) {
		return null;
	}

	const handleClick = () => {
		window.location.href = linkRedirect;
	};

	const handleClose = () => {
		Cookies.set(cookieName, 'closed', {secure: true, expires: 1});
		setOpenState(false);
	};

	const productTitle = {
		[ProductEnum.GNDI]: gndi,
		[ProductEnum.CLINIPAM]: clinipam,
		[ProductEnum.CCG]: ccg,
		[ProductEnum.GNDI_MINAS]: gndiminas,
		[ProductEnum.HAP]: hapvida,
		[ProductEnum.NOTREDAME_SAUDE]: notredamesaude,
	};

	return (
		<StyledContainer sx={{display: openState ? 'flex' : 'none', marginBottom}}>
			<StyledContent>
				<IconButton size="small" onClick={handleClose}>
					<Icon name="close-default" />
				</IconButton>
				<StyledIcon>{dataHostNameState.productAppIcon({})}</StyledIcon>
				<Stack>
					<Typography color={'text.primary'} variant="body2">
						{productTitle[dataHostNameState.product]}
					</Typography>
					<Typography color={'text.secondary'} variant="caption">
						{useApp}
					</Typography>
				</Stack>
			</StyledContent>
			<Button sx={{boxShadow: 'none'}} onClick={handleClick}>
				{seeApp}
			</Button>
		</StyledContainer>
	);
}
